import { ComponentSingleStyleConfig } from "@chakra-ui/react";
import { darkForest } from "../foundations/colors";

const Tooltip: ComponentSingleStyleConfig = {
  baseStyle: { bg: darkForest },
};

export default Tooltip;
